module.exports = __webpack_public_path__ + "img/dzg_vi.a74d2ef3.png";